"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_smarthome__kit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Smarthome_kit_hi",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi",
    "data-name": "Apps ic hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "163.9 60.56 163.9 131.95 96.06 164.08 28.11 131.95 28.11 60.56 28.11 60.46 97.06 29.93 163.9 60.46",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.86 72.84 124.45 40.96 133.74 44.8 65.45 77.31 55.86 72.84",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.3 77.36 133.74 44.8 133.74 45.7 65.3 78.35 65.3 77.36",
    style: {
      fill: "#900"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.06 164.08 163.9 131.95 163.9 63.78 163.9 60.56 163.9 60.46 96.02 91.77 96.06 164.08",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96 163.77 96 91.77 28.11 60.56 28.11 131.95 96.06 164.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.06 164.08 163.9 131.95 163.9 63.78 163.9 60.56 163.9 60.46 96.02 91.77 96.06 164.08",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96 163.77 96 91.77 28.11 60.56 28.11 131.95 96.06 164.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.06 164.08 163.9 131.95 163.9 63.78 163.9 60.56 163.9 60.46 96.02 91.77 96.06 164.08",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,91.77h0v72.31L163.9,132v-2L96.07,162.08Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96 163.77 96 91.77 28.11 60.56 28.11 131.95 96.06 164.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96 162.05 28.11 129.95 28.11 131.95 96.06 164.08 96 163.77 96 162.05",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,160.45",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.45 77.31 65.45 109.49 55.86 104.96 55.86 72.84 65.45 77.31",
    style: {
      fill: "#bd0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.25 76.92 66.07 109.08 65.45 109.49 65.45 77.31 66.25 76.92",
    style: {
      fill: "#900"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.74 44.8 133.74 46.69 132.68 46.2 132.68 45.31 133.74 44.8",
    style: {
      fill: "#900"
    }
  })));
}

var _default = ic_smarthome__kit;
exports.default = _default;